import { ErrorDTO } from "@scrile/api-provider/dist/lib/apiErrorHandler";

export const extractRestrictedWords = (error: ErrorDTO): string[] => {
  const data = error.details?.data;
  if (!data || !Array.isArray(data.keywords)) return [];
  return data.keywords;
};
